var render = function render(_c,_vm){return _c('div',{staticClass:"card-boolean"},[(!!_vm.props.value)?_c('i',{staticClass:"iconoir-check"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }